<template>
    <div class="menu-content">
        <div class="btn-close" :class="{'closed': !show}" @click="toggleClose">
            <i class="fa" :class="{'fa-times': show, 'fa-chevron-up': !show}"></i>
        </div>
        <div class="row center-xs list" v-if="show">
            <div class="col-xs-2"><img src="@/assets/imgs/logos/FIA.png"></div>
            <div class="col-xs-2"><img src="@/assets/imgs/logos/OMDAI.png"></div>
            <div class="col-xs-2"><img src="@/assets/imgs/logos/FCS.png"></div>
            <div class="col-xs-2"><img src="@/assets/imgs/logos/PILOTOS.png"></div>
            <div class="col-xs-2"><img src="@/assets/imgs/logos/NISSAN.png"></div>
            <div class="col-xs-2"><img src="@/assets/imgs/logos/CRUZ-ROJA.png"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'menu-footer-component',
        props: {
            show: {
                required: false,
                default: true
            }
        },
        mounted() {
            /*this.$root.$on('menufooter:show', () => {
                console.log('MenuFooter On', this.show);
                if (!this.show) {
                    this.toggleClose();
                }
            })*/
        },
        data() {
            return {}
        },
        methods: {
            toggleClose() {
                this.$emit('toggleClose')
            }
        }
    };
</script>

<style lang="sass" scoped>

    .menu-content
        position: relative
        height: 100%
        box-sizing: border-box
        .list
            background-color: rgba(248, 248, 255, 0.9)
            padding: 8px
            transition: all .4s ease-in-out
            img
                height: 60px
                width: auto
                max-width: 100%
                @media only screen and (max-width: 48em)
                    max-height: 100%
                    height: auto
        .btn-close
            display: none
            /*@media screen and (min-width: 48em)
                position: absolute
                top: 16px
                right: 16px
                color: white
                border-radius: 3em
                background-color: rgba(0, 0, 0, .2)
                -webkit-transition: all .4s ease-in-out
                -moz-transition: all .4s ease-in-out
                -ms-transition: all .4s ease-in-out
                -o-transition: all .4s ease-in-out
                transition: all .4s ease-in-out
                z-index: 9
                display: block
                padding: 5px 7px 5px 7px*/

</style>
